import { type FC } from "react";
import { useParams } from "react-router-dom";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { GatedRoute } from "../../core/routes/GatedRoute";
import { CofConfigId } from "../../gql-generated/types";

import { LensStudioCreateOrganizationAndLensSpace } from "./LensStudioCreateOrganizationAndLensSpace";
import { LensSubmissionCreateOrganizationAndLensSpace } from "./LensSubmissionCreateOrganizationAndLensSpace";
import { WebLensCreateOrganizationAndLensSpace } from "./WebLensCreateOrganizationAndLensSpace";

const renderRoute = (routeTo: RouteParams[AbsoluteRoute.CREATE_ORG_LENS_FOLDER]["routeTo"]) => {
    switch (routeTo) {
        case "lens-studio":
            return <LensStudioCreateOrganizationAndLensSpace />;
        case "submit":
            return <LensSubmissionCreateOrganizationAndLensSpace />;
        case "web-lens":
            return (
                <GatedRoute gateKey={CofConfigId.MyLensesWebLensPublication}>
                    <WebLensCreateOrganizationAndLensSpace />
                </GatedRoute>
            );
        default:
            return null;
    }
};

export const CreateOrganizationAndLensFolderWrapper: FC = () => {
    const { routeTo } = useParams<RouteParams[AbsoluteRoute.CREATE_ORG_LENS_FOLDER]>();
    if (!routeTo) {
        return null;
    }

    return renderRoute(routeTo);
};
